import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import './components/Common/ToolBarSearch.scss';
import React from 'react';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from 'App';
import { getAppInsights, reactPlugin } from './ApplicationInsights';
import AuthProvider, { AuthProviderVariables } from './AuthProvider';
import { unregister } from './registerServiceWorker';
import configureStore from './store/configureStore';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl } as any);

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = (window as any).initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

const getUrlVars = () => {
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value): any {
        vars[key] = value;
    });
    return vars;
};
const urlAccessToken = getUrlVars()['cc_access_token'];

const renderContent = () => {
    return (
        <Provider store={store}>
            <ReduxRouter history={history} store={store}>
                <AppInsightsErrorBoundary onError={() => <h1>something went wrong</h1>} appInsights={reactPlugin}>
                    <App />
                </AppInsightsErrorBoundary>
            </ReduxRouter>
        </Provider>
    );
};

if (urlAccessToken) {
    const appInsights = getAppInsights();
    appInsights.trackEvent({ name: 'AVA-Member-UI-Login-UrlAccessToken' });
    sessionStorage.setItem(AuthProviderVariables.CC_ACCESS_TOKEN, urlAccessToken);
    ReactDOM.render(renderContent(), rootElement);
    unregister();
} else {
    ReactDOM.render(<AuthProvider>{renderContent()}</AuthProvider>, rootElement);

    unregister();
}
